import axios from 'axios'
import { Toast } from 'vant'
import qs from 'qs'
import { serverUrl, serverUrlOld, uploadUrl } from '@/api/baseMap'
import { appLogin, miniLogin, mLogin, staffLogin } from '@/assets/js/aboutLogin'
import { getEnv, getUrlData } from '@/assets/js/common.js'
import { loginByApp } from '@/assets/js/oneHigh.js'

// c端登录   小程序  app  m站登录
async function handleLogin() {
  console.log('接口报未登录')
  if (localStorage.oneHigh == 1) {
    console.log('一嗨渠道去登陆')
    // 一嗨渠道
    loginByApp()
  } else if (localStorage.thirdLogin == 1) {
    console.log('第三方内嵌去登陆')
    // 第三方内嵌
    mLogin.callMLogin()
  } else {
    getEnv().then((env) => {
      if (env == 'zfb_mini') {
        my.redirectTo({ url: `/pages/login/login?url=${encodeURIComponent(window.location.href)}` })
      } else if (env == 'mini') {
        console.log('mini端接口报未登录')
        miniLogin.callMiniLogin()
      } else if (env == 'app') {
        console.log('app端接口报未登录')
        let callbackObj = {
          callback: function (data) {
            console.log('调用app登录回调函数入参', data)
            sessionStorage.sign = data
          },
        }
        if (location.href.includes('/rent/v2/discover/travelNoteDetail')) {
          callbackObj.contentType = getUrlData().type || 1
        }
        if (localStorage.play24 == 1) {
          appLogin.callApp24Login(callbackObj)
        } else {
          appLogin.callAppLogin(callbackObj)
        }
      } else {
        console.log('m站接口报未登录')
        mLogin.callMLogin()
      }
    })
  }
}

/**
 *
 * 正常的接口请求
 *
 */
// 创建axios实例
const request = axios.create({
  baseURL: serverUrl,
  timeout: 1000 * 20,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
  withCredentials: true,
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    if (config.method == 'post') {
      let obj = JSON.parse(JSON.stringify(config.data))
      obj.c = JSON.stringify({ clientType: 5, deviceType: '', appVersion: '', p: '', cityId: '' })
      config.data = qs.stringify(obj)
    } else {
      config.params = { c: JSON.stringify({ clientType: 5, deviceType: '', appVersion: '', p: '', cityId: '' }) }
    }

    return config
  },
  (error) => Promise.error(error)
)

// 响应拦截器
request.interceptors.response.use(
  (res) => {
    // 请求成功
    if (res.status == 200) {
      //http表示成功的状态
      //下面的我们自己的服务端逻辑
      if (res.data.success || res.data.code == 0 || res.data.statusCode == 0) {
        return Promise.resolve(res.data)
      } else {
        if (
          res.data.errorCode == 41001 ||
          res.data.errorCode == 42001 ||
          res.data.errorCode == 42002 ||
          res.data.errorCode == 401
        ) {
          //需要登录
          handleLogin()
          Toast.clear()
        } else if (res.data.errorCode == 20001) {
          return Promise.resolve(res.data)
        } else if (res.data.errorCode == 111111) {
          staffLogin()
          Toast.clear()
        } else {
          Toast({
            message: res.data.msg,
            duration: 2000,
          })
          return Promise.resolve(res.data)
        }
      }
    } else {
      Toast({
        message: '服务器异常',
        duration: 2000,
      })
      // return Promise.reject(res.data).catch(() => {})
    }
  },
  // 请求失败
  (error) => {
    Toast.clear()
    Toast({
      message: '服务器异常',
      duration: 2000,
    })
  }
)

/**
 *
 * 老代码中的接口请求
 *
 */
// 创建axios实例
const oldRequest = axios.create({
  baseURL: serverUrlOld,
  timeout: 1000 * 20,
  headers: { 'Content-Type': 'application/json;charset=UTF-8' },
})
// 响应拦截器
oldRequest.interceptors.response.use(
  (res) => {
    // Toast.clear()
    // 请求成功
    if (res.status == 200) {
      if (res.data.statusCode == 0) {
        return Promise.resolve(res.data)
      } else {
        // if (res.data.data) {
        Toast({
          message: res.message,
          duration: 2000,
        })
        // }
        return Promise.resolve(res.data)
      }
    } else {
      Toast({
        message: '服务器异常',
        duration: 2000,
      })
    }
  },
  // 请求失败
  (error) => {
    Toast.clear()
    Toast({
      message: '服务器异常',
      duration: 2000,
    })
  }
)

/**
 *
 * 上传图片接口请求
 *
 */
const uploadImageRequest = axios.create({
  baseURL: uploadUrl,
  timeout: 1000 * 20,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
  withCredentials: true,
})

// 响应拦截器
uploadImageRequest.interceptors.response.use(
  (res) => {
    Toast.clear()
    // 请求成功
    if (res.status == 200) {
      //http表示成功的状态
      //下面的我们自己的服务端逻辑
      if (res.data.success || res.data.code == 0) {
        return Promise.resolve(res.data)
      } else {
        if (
          res.data.errorCode == 41001 ||
          res.data.errorCode == 42001 ||
          res.data.errorCode == 42002 ||
          res.data.code == '0042002' ||
          res.data.code == '0042001'
        ) {
          //需要登录
          handleLogin()
        } else {
          Toast({
            message: res.data.msg,
            duration: 2000,
          })
          return Promise.resolve(res.data)
        }
      }
    } else {
      Toast({
        message: '服务器异常',
        duration: 2000,
      })
      // return Promise.reject(res.data).catch(() => {})
    }
  },
  // 请求失败
  (error) => {
    Toast.clear()
    Toast({
      message: '服务器异常',
      duration: 2000,
    })
  }
)

export { request, oldRequest, uploadImageRequest }



// WEBPACK FOOTER //
// ./src/assets/js/request.js